import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import moment from 'moment';
import { Pharmacy } from './Pharmacy';

export const TransferRequest = types.compose(
  'TransferRequest',
  BaseEntity,
  types.model({
    transferRequestId: types.identifierNumber,
    apbNumber: types.maybe(types.number),
    requestDate: types.optional(types.string, moment().format()),
    initialAddress: types.maybe(types.string),
    initialZipCode: types.maybe(types.string),
    initialCity: types.maybe(types.string),
    newAddress: types.maybe(types.string),
    newZipCode: types.maybe(types.string),
    newCity: types.maybe(types.string),
    apbNumberToClose: types.maybe(types.number),
    procedure: types.maybe(types.string),
    decisionDate: types.optional(types.string, moment().format()),
    decision: types.maybe(types.string),
    chamber: types.maybe(types.string),
    firstPublishDate: types.optional(types.string, moment().format()),
    firstPublishDateAfterDecision: types.optional(types.string, moment().format()),
    cancelDate: types.optional(types.string, moment().format()),
    protectionStartDate: types.optional(types.string, moment().format()),
    protectionEndDate: types.optional(types.string, moment().format()),
    protectionDuration: types.maybe(types.integer),
    protectionDurationUom: types.maybe(types.string),
    protectionRange: types.maybe(types.integer),
    protectionRangeUom: types.maybe(types.string),}),
);

